import { render, staticRenderFns } from "./ScrollDownText.vue?vue&type=template&id=046e1638&scoped=true&"
import script from "./ScrollDownText.vue?vue&type=script&lang=js&"
export * from "./ScrollDownText.vue?vue&type=script&lang=js&"
import style0 from "./ScrollDownText.vue?vue&type=style&index=0&id=046e1638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046e1638",
  null
  
)

export default component.exports